import axios from "axios";
import { BASE_URL } from "../../constants/api-staging";

export default async function updatePartialNotification(id, partialNotification) {
    return axios.patch(`${BASE_URL}/notification/${id}`,partialNotification, {
        headers : {
            Authorization: localStorage.getItem("token")
        }
    });
}